import { AfterViewInit, Injectable, OnDestroy } from "@angular/core";
import { set as _set } from "lodash";
import { BehaviorSubject ,  Subscription } from "rxjs";
import { NSFormFields } from "../../../../types";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class DropdownStateService extends FieldStateService implements AfterViewInit, OnDestroy {
    public stateObservable$: BehaviorSubject<any>;
    public stateSubscriber$: Subscription;
    public fieldOptions: NSFormFields.IOptionsState[];

    constructor() {
        super();
    }

    private setFieldOptions() {
        this.stateSubscriber$ = this.stateObservable$.subscribe((state) => {
            this.fieldOptions = state.options;
        });
    }

    public ngAfterViewInit() {
        this.setFieldOptions();
    }

    public ngOnDestroy() {
        this.stateSubscriber$.unsubscribe();
    }

    public dispatchFieldUpdate(payload, index?) {
        this.setFieldOptions();
        if (!this.fieldOptions) {
            return;
        }
        const newState = super.newState({});
        const options = this.fieldOptions;
        index = index || options.findIndex((row) => row.value === payload);
        _set(newState, ["options", index, "state"], payload);
        const selectedOption = options[index] || { value: undefined, label: undefined };
        newState.value = selectedOption.value;
        newState.selectedValue = selectedOption.value;
        newState.selectedLabel = selectedOption.label;
        this.stateObservable$.next(newState);
    }

    public dispatchFieldLoad(payload): void {
        this.dispatchFieldUpdate(payload);
    }

    public dispatchListLoad(payload, ...args): void {
        const fieldOptionsLabelPath = args[0];
        const fieldOptionsIdPath = args[1];
        const options = payload.map((option) => {
            return {
                label: option[fieldOptionsLabelPath] || option.label,
                value: option[fieldOptionsIdPath] || option.value,
                state: undefined,
            };
        });
        this.stateObservable$.next(super.newState({ options }));
    }

    public dispatchStateReset(initialState): void {
        const options = this.fieldOptions;
        this.stateObservable$.next(super.newState({ options }));
    }
}
